( function ( $ ) {

	$( '.section-guide_heading .sections .button' ).on( 'click', function ( event ) {
		event.preventDefault();

		var target = $( this ).attr( 'href' );
		var $targetElem = $( target );

		if ( $targetElem.length ) {
			var top = $targetElem.offset().top;
			var headerHeight = $( '.site-header .header-content' ).height();
			var contentOffset = top - headerHeight;
			$( 'html, body' ).stop().animate( { scrollTop: contentOffset }, 500, 'swing' );
		}
	} );

	const $slider = $( '.section-rating_categories .slider' );

	$( window ).on( 'load resize', function () {
		initRatingCategoriesSlider( $slider );
	} );

	function initRatingCategoriesSlider( $sliderEl ) {
		if ( window.innerWidth <= 1200 && ( !$slider.hasClass( 'slick-initialized' ) ) ) {
			$sliderEl.slick( {
				slidesToShow: 1,
				slidesToScroll: 1,
				infinite: false,
				mobileFirst: true,
				prevArrow: $( '.section-rating_categories .nav .prev' ),
				nextArrow: $( '.section-rating_categories .nav .next' ),
				responsive: [
					{
						breakpoint: 1199,
						settings: 'unslick'
					},
					{
						breakpoint: 992,
						settings: {
							slidesToShow: 4
						}
					},
					{
						breakpoint: 767,
						settings: {
							slidesToShow: 3
						}
					},
					{
						breakpoint: 567,
						settings: {
							slidesToShow: 2
						}
					}
				]
			} ).on( 'swipe', function ( event ) {
				$( '.section-rating_categories .rating-category' ).removeClass( 'hover' );
			} );
		}
	}

	initRatingCategoriesSlider( $slider );


	$( '.section-rating_categories .rating-category' ).on( 'click', function ( event ) {
		event.preventDefault();
		$( '.section-rating_categories .rating-category' ).not( this ).removeClass( 'hover' );
		$( this ).toggleClass( 'hover' );
	} );

	$( '.section-rating_categories .category-toggler .button' ).on( 'click', function ( event ) {
		event.preventDefault();
		$( '.section-rating_categories .rating-category' ).toggleClass( 'on' );
		$( this ).toggleClass( 'on' );
		if ( $( this ).text() == $( this ).attr( 'data-label-show' ) ) $( this ).text( $( this ).attr( 'data-label-hide' ) );
		else $( this ).text( $( this ).attr( 'data-label-show' ) );
	} );

	$( '.section-content_descriptors .descriptors' ).tabs( {
		hide: 300,
		show: 300,
		beforeActivate: function ( event, ui ) {
			$( '.descriptors .content' ).hide();
			$( '.descriptors .title a' ).removeClass( 'on' );
		}
	} );

	$( '.descriptors .more .button' ).on( 'click', function ( event ) {
		event.preventDefault();
		$( this ).closest( '.descriptors' ).find( '.hidden-xs-down' ).removeClass( 'hidden-xs-down' );
		$( this ).closest( '.descriptors' ).find( '.hidden' ).removeClass( 'hidden' );
		$( '.descriptors .more' ).hide();
		$( '.descriptors .less' ).show();
	} );

	$( '.descriptors .less .button' ).on( 'click', function ( event ) {
		event.preventDefault();
		$( this ).closest( '.descriptors' ).find( '.hideable' ).addClass( 'hidden' );
		$( '.descriptors .more' ).show();
		$( '.descriptors .less' ).hide();
	} );

	$( '.descriptor a' ).on( 'click', function ( event ) {
		event.preventDefault();
		var $thisContent = $( this ).closest( '.descriptor' ).find( '.content' );

		$( '.descriptors .content' ).not( $thisContent ).hide();
		$( '.descriptors .title a' ).not( $( this ) ).removeClass( 'on' );
		$thisContent.slideToggle( 200 );
		$( this ).toggleClass( 'on' );
	} );

} )( jQuery );